import { Ico_Filter_Component, Ico_SortAscending, Ico_SortDescending, Ico_Warning, PageTitle, useSnackbar } from '@sagecentral/core-ui';
import { Box, Button, CircularProgress, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { WorkItemSearchCriteria } from "hooks/work-items/useWorkItem";
import { GridBox, GridNoRowsOverlay, GridToolbar } from "components/shared/grids";
import { GetAutocompleteResult } from "hooks/work-items/useWorkItemAutocompleteResource";
import { DataGridPro, DataGridProProps, GridColDef, GridFooter, GridFooterContainer, GridRenderCellParams, GridRowModel, GridRowProps, GridRowSelectionModel, GridTreeNodeWithRender, useGridApiRef } from "@mui/x-data-grid-pro";
import moment from "moment";
import WorkItemRow from './shared/WorkItemRow';
import BulkUpdateOpertionsResponsibilities from './shared/BulkUpdateOperationsResponsibilities';
import useWorkItemsWithResources, { AssignedUser, WorkItemWithResources } from 'hooks/work-items/useWorkItemWithResources';
import { IChangedWorkItemResourceAssigne, ISaveWorkItemResourceAssigne } from 'models/work-items/IChangedWorkItemResourceAssignee';
import useBulkUpdateSaveWorkItemResources from 'hooks/work-items/useBulkUpdateSaveWorkItemResources';
import WorkItemResourceReviewChanges from './WorkItemResourceReviewChanges';
import { useWorkItemResourcesColumnsv2 } from './grid'
import { useBulkUpdateWorkItemPermissions } from "hooks/work-items";
import BulkUpdateSearchResources from './shared/resources/BulkUpdateSearchResources';
import { useNavigationPrompt } from 'hooks/shared/useNavigationPrompt';
import { useFeatureEnabled, useGoBack } from 'hooks/shared';
import { Helmet } from 'react-helmet';

const NoRowsOverlay = (searched: boolean) => {
    return (
        <GridNoRowsOverlay text={searched ? 'No results found.' : ' '} />
    );
};

const CustomFooter = (total: number) => {

    return (
        <GridFooterContainer>
            <Box sx={{ pl: '8px' }}>Total Records: {total}</Box>
            <GridFooter>
            </GridFooter>
        </GridFooterContainer>
    );
};

const WorkItemBulkUpdateResources = () => {
    const { displaySnackbar } = useSnackbar();
    const pageTitle = `Bulk Update Work Item - Resources`;
    const back = useGoBack('/workitems/my/in-progress');
    const apiRef = useGridApiRef();
    const workItemPermissions = useBulkUpdateWorkItemPermissions();
    const [drawer, setDrawer] = useState(false);
    const [selectedWorkItemRows, setSelectedWorkItemRows] = useState<GridRowSelectionModel>([]);
    const [selectedWorkItemIds, setSelectedWorkItemIds] = useState<number[]>([]);
    const [selectedResponsibilityIds, setSelectedResponsibilityIds] = useState<number[]>([]);
    const [openEmptySearchCriteriaNotificationDialog, setEmptySearchCriteriaNotificationDialog] = useState<boolean>(false);
    const [openSearchWithoutSaveConfirmation, setOpenSearchWithoutSaveConfirmation] = useState<boolean>(false);
    const [doSearchResources, setDoSearchResources] = useState<boolean>(false);
    const [selectedWorkSpaceIds, setSelectedWorkSpaceIds] = useState<number[]>([]);
    const [changedWorkItems, setChangedWorkItems] = useState<IChangedWorkItemResourceAssigne[]>([]);
    const [resourceWorkItemsToUpdate, setResourceWorkItemsToUpdate] = useState<ISaveWorkItemResourceAssigne[]>([]);
    const [taskTracking, setTaskTracking] = useState<string | undefined>(undefined);
    const [disableSave, setDisableSave] = useState<boolean>(false);
    const [userSearched, setUserSearched] = useState<boolean>(false);
    const [selectedResource, setSelectedResource] = useState<GetAutocompleteResult>();
    const [searchPayload, setSearchPayload] = useState<WorkItemSearchCriteria>({
        contentType: [0],
        resource: '',
        status: [0],
        workItemSearchText: '',
        workspaces: [],
        resourceOnlyAsPrimary: false,
        includeChildWorkItems: false,
        searchAll: true,
        userId: '',
        responsibilities: [],
        responsibilityUseOrOperator: false,
        matchOnPrimary: false,
        hash: 0
    });

    const [unsavedChanges, setUnsavedChanges, showPrompt, confirmNavigation, cancelNavigation] = useNavigationPrompt()

    const onChange = (changeType: string, params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>, event: any): void => {
        if (changeType === 'responsibility') {
            const rowId = params.row.id;
            const path = rowId.toString().split('/');
            const wiId = path[path.length - 1];
            const selectedResponsibilityId = event.target.value;
            const repeatedWorkItems: any[] = params.api.getSortedRows().filter((x: any) => x.workItemInstanceId === parseInt(wiId));
            repeatedWorkItems.forEach(row => {
                row.selectedResponsibilityId = selectedResponsibilityId;
            });

            params.row.selectedResponsibilityId = selectedResponsibilityId;
            apiRef.current.setCellFocus(params.row.id, 'resources');
        }

        if (changeType === 'resource') {
            //onResourceChange(event, params);
        }
    }

    const onUpdateSelectedRows = (newRowSelectionModel: GridRowSelectionModel) => {
        var workItems = workItemsForBulkUpdateResources;

        if (workItems === null || workItems === undefined) {
            return;
        }

        const deselectedIds = selectedWorkItemRows.filter(x => !newRowSelectionModel.includes(x));
        const newSelectedIds = newRowSelectionModel.filter(x => !selectedWorkItemRows.includes(x));
        const updatedRowSelectionModel = [...newRowSelectionModel];
        newSelectedIds.map(gridId => {
            const path = gridId.toString().split('/');
            const wiId = path[path.length - 1];
            const repeatedWorkItems = workItems!.workItems!.filter(x => x.workItemInstanceId === parseInt(wiId) && x.treePath !== gridId);
            repeatedWorkItems.forEach(x => {
                updatedRowSelectionModel.push(...repeatedWorkItems.map(x => x.treePath));
            });
        });

        deselectedIds.map(gridId => {
            const path = gridId.toString().split('/');
            const wiId = path[path.length - 1];
            const repeatedWorkItems = workItems!.workItems!.filter(x => x.workItemInstanceId === parseInt(wiId));
            repeatedWorkItems.forEach(x => {
                x.errorMessage = '';
                const index = newRowSelectionModel.findIndex(y => y === x.treePath);
                if (index > -1) {
                    updatedRowSelectionModel.splice(index, 1);
                }
            });
        });

        setSelectedWorkItemRows([...updatedRowSelectionModel.filter((value, index, array) => array.indexOf(value) === index)]);

        const workSpaceIds: number[] = [];
        const workItemIds: number[] = [];
        const responsibilityIds: number[] = [];
        newRowSelectionModel.forEach(treePath => {
            const workItem = workItems!.workItems!.find(x => x.treePath === treePath);
            if (workItem && !workSpaceIds.includes(workItem.workspaceInstanceId)) {
                workSpaceIds.push(workItem.workspaceInstanceId);
            }
            if (workItem && !workItemIds.includes(workItem.workItemInstanceId)) {
                workItemIds.push(workItem.workItemInstanceId);
            }
            if (workItem && !responsibilityIds.includes(workItem.responsibilityId)) {
                responsibilityIds.push(workItem.responsibilityId);
            }
        })
        setSelectedWorkSpaceIds(workSpaceIds);
        setSelectedWorkItemIds(workItemIds);
        setSelectedResponsibilityIds(responsibilityIds);
    }

    const rowCellEdited = (params: any) => {
        const path = params.row.treePath.toString().split('/');
        const wiId = path[path.length - 1];
        const changedSelectionIds: string[] = [];
        changedSelectionIds.push(params.row.treePath);
        setSelectedWorkItemRows(selectedWorkItems => ([...selectedWorkItems, ...changedSelectionIds]));
    }

    const validateRow = (props: GridRowProps) => {

        // WILL BE CLEANED UP IN THE BFLY-12189.

        // var [result, workItems] = [saveBulkUpdateResourcesResult, workItemsForBulkUpdateResources];

        // const resultRowValidation = result?.results?.find(x => x.workItemInstanceId === props.row?.workItemInstanceId);
        // const wiWithError = (workItems && workItems.workItems.length > 0) ? workItems.workItems.find(x => !!x.errorMessage && props.row?.workItemInstanceId == x.workItemInstanceId) : "";

        // if (resultRowValidation && !resultRowValidation.valid) {
        //     return { checked: true, valid: false };
        // }

        // if (resultRowValidation && resultRowValidation.valid) {
        //     return { checked: true, valid: true };
        // }

        // if (wiWithError && (wiWithError as WorkItem).errorMessage) {
        //     return { checked: true, valid: false };
        // }

        return { checked: false, valid: false };
    }

    const getRowErrorMessage = (props: GridRowProps) => {
        var [result, workItems] = [saveBulkUpdateResourcesResult, workItemsForBulkUpdateResources];

        const workItemValidations = result?.results?.filter(x => x.workItemInstanceId === props.row?.workItemInstanceId && !x.valid) ?? [];
        const wiWithError = (workItems && workItems.workItems.length > 0) ?
            workItems.workItems.find(x => x.errorMessage != null && props.row?.workItemInstanceId == x.workItemInstanceId) :
            "";

        var validationMessage = '';
        workItemValidations?.forEach(workItemValidation => {

            if (workItemValidation) {
                const responsibility = (props.row as WorkItemWithResources).responsibilitiesResources.find(x => x.responsibilityId === workItemValidation.responsibilityId);
                const resource = responsibility?.resources?.find(x => x.userId === workItemValidation.userId);

                if (workItemValidation.concurrency) {
                    validationMessage += `Work item resource for Responsibility${responsibility ? ` ${responsibility?.responsibilityName}` : ''} was updated by someone else.`;
                }
                if (workItemValidation.resourceMissing) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}Work item has no resource assigned`;
                }
                if (workItemValidation.successorTaskStatus) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}The work item has either active/or completed successors`;
                }
                if (workItemValidation.statusTransitionPossible) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}The status transition to/from this status is not allowed`;
                }
                if (workItemValidation.responsibilityNotInWorkItem) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}Responsibility does not exist in Work item.`;
                }
                if (workItemValidation.userNotInWorkSpace) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}The new resource added${!!resource ? ` ${resource.userName}` : ''} for Responsibility${responsibility ? ` ${responsibility?.responsibilityName}` : ''} does not exist in workspace.`;
                }
                if (workItemValidation.userNotFoundInWorkItem) {
                    validationMessage += `${validationMessage === '' ? '' : ', '}Assigned resource${!!resource ? ` ${resource.userName}` : ''} for Responsibility${responsibility ? ` ${responsibility?.responsibilityName}` : ''} was neither new nor present in workitem.`;
                }
            }
        });
        return validationMessage ? validationMessage : (wiWithError ? wiWithError.errorMessage : null);
    }
    const [wave4Enabled] = useFeatureEnabled('wave-4');
    const bulkUpdateResourcesColumns = useWorkItemResourcesColumnsv2(onChange, apiRef, workItemPermissions, wave4Enabled);
    const [workItemsForBulkUpdateResources, loadingWorkItemsForBulkUpdateResources, errorWorkItemsForBulkUpdateResources, setWorkItemsForBulkUpdateResources] = useWorkItemsWithResources(searchPayload, { page: 1, pageSize: 100 }, doSearchResources, setDoSearchResources);
    //const [saveBulkUpdateResourcesResult, saveBulkUpdateResourcesInProgress, saveBulkUpdateResourcesResultError, setSaveBulkUpdateResourcesResult, saveBulkUpdateResourcesWorkItems] = useBulkUpdateSaveWorkItemResources([],'');//useBulkUpdateSaveWorkItemResources(resourceWorkItemsToUpdate, taskTracking);
    const [saveBulkUpdateResourcesResult, saveBulkUpdateResourcesInProgress, saveBulkUpdateResourcesResultError, setSaveBulkUpdateResourcesResult, saveBulkUpdateResourcesWorkItems] = useBulkUpdateSaveWorkItemResources(resourceWorkItemsToUpdate, taskTracking);


    useEffect(() => {
        if (resourceWorkItemsToUpdate && resourceWorkItemsToUpdate.length > 0 && taskTracking) {
            saveBulkUpdateResourcesWorkItems();
        }
    }, [resourceWorkItemsToUpdate, taskTracking]);

    useEffect(() => {
        if (saveBulkUpdateResourcesResult) {
            switch (saveBulkUpdateResourcesResult.statusResponse) {
                case 'ok':
                    displaySnackbar('success', 'Work Items saved. See email for details.');
                    break;
                case 'error':
                    displaySnackbar('error', 'Work Items did not save. See email for details.');
                    break;
                default:
                    break;
            }
            setUnsavedChanges(false);
        }
    }, [saveBulkUpdateResourcesResult]);

    const getData: (() => GridRowModel[]) = () => {
        return getResourcesData();
    }

    const getResourcesData: (() => GridRowModel[]) = useMemo(() => {
        return () => (loadingWorkItemsForBulkUpdateResources ? [] : (workItemsForBulkUpdateResources?.workItems ?? []))
    }, [workItemsForBulkUpdateResources]);

    const getColumns: (() => GridColDef[]) = () => {
        return bulkUpdateResourcesColumns;
    }

    const handleSearch = (payload: WorkItemSearchCriteria, ignoreConfirmation: boolean) => {
        if (unsavedChanges && ignoreConfirmation) {
            setOpenSearchWithoutSaveConfirmation(true);
            setSearchPayload(payload);
            return;
        }

        if (payload.resource === ''
            && payload.responsibilities.length === 0
            && payload.workItemSearchText === ''
            && payload.workspaces.length === 0
            && payload.status.length === 0
            && payload.contentType.length === 0) {
            setEmptySearchCriteriaNotificationDialog(true);
            return;
        }
        setOpenSearchWithoutSaveConfirmation(false);
        setUnsavedChanges(false);
        cleanResults();
        setSearchPayload(payload);
        setDoSearchResources(true);
        setTimeout(() => {
            setUserSearched(true);
        }, 10);
    }

    const handleOnCancel = () => {
        back();
    }

    const validateAndUpdateWorkItem = (wi: WorkItemWithResources, selectedResource: AssignedUser, boResource: GetAutocompleteResult, responsibility: number[]): boolean => {
        let isUpdated = true;
        let isChangePresent = false;
        responsibility.map(boResponsibility => {
            wi.errorMessage = null;
            //const boResponsibility = responsibility.at(0) as number;
            const responsibilityOnWi = wi?.responsibilitiesResources?.find(resp => resp.responsibilityId == boResponsibility);
            if (responsibilityOnWi !== null && responsibilityOnWi !== undefined) {
                const currentAssignee = responsibilityOnWi.resources.find(df => df.selected);
                const selectedResourceAlreadyPresent = responsibilityOnWi.resources.find(rr => rr.userId == selectedResource.userId);
                const newRewsourceWorkspaceIds = boResource.workspaceInstanceIds?.split(',');

                if (newRewsourceWorkspaceIds !== undefined && newRewsourceWorkspaceIds.indexOf('' + wi.workspaceInstanceId) < 0) {
                    wi.errorMessage = "The resource selected is not in the work item’s Workspace.";
                    wi.error = true;
                    isUpdated = false;
                } else if (!selectedResourceAlreadyPresent) {
                    selectedResource.isNew = true;
                    if (selectedResource.selected) {
                        if (currentAssignee) {
                            currentAssignee.selected = false;
                        }
                    }
                    //If responsibility dont have resource at work item
                    if (responsibilityOnWi.resources.length === 1 && responsibilityOnWi.resources[0].userId === '') {
                        responsibilityOnWi.resources[0].selected = true;
                        responsibilityOnWi.resources[0].isDefaultAssignee = false;
                        responsibilityOnWi.resources[0].isNew = true;
                        responsibilityOnWi.resources[0].userId = selectedResource.userId;
                        responsibilityOnWi.resources[0].userName = selectedResource.userName;
                        responsibilityOnWi.resources[0].isAssignOnInProgress = selectedResource.isAssignOnInProgress;
                        //addToNewResponsibility(wi, responsibilityOnWi, selectedResource);
                    }
                    else {
                        responsibilityOnWi.resources.push(selectedResource);
                        //addToNewResponsibility(wi, responsibilityOnWi, selectedResource);
                    }
                    wi.selectedResponsibilityId = boResponsibility;
                    wi.selectedResponsibility = responsibilityOnWi;
                }
                else {
                    //Update case
                    if (selectedResourceAlreadyPresent != undefined && selectedResourceAlreadyPresent != null) {
                        isChangePresent = true;
                    }
                    if (wi.newResponsibilitiesResources != undefined && wi.newResponsibilitiesResources.filter(f => f.responsibilityId === responsibilityOnWi.responsibilityId).length > 0) {
                        var addedResources = wi.newResponsibilitiesResources.filter(f => f.responsibilityId === responsibilityOnWi.responsibilityId)[0].resources;
                        if (addedResources !== undefined && addedResources.filter(f => f.userId == selectedResource.userId)) {
                            isChangePresent = true;
                        }
                    }
                    if (selectedResourceAlreadyPresent.selected !== selectedResource.selected) {
                        selectedResourceAlreadyPresent.selected = selectedResource.selected;
                        selectedResourceAlreadyPresent.isAssignOnInProgress = selectedResource.isAssignOnInProgress;
                        if (currentAssignee) {
                            currentAssignee.selected = false;
                        }
                    }
                    else if (!isChangePresent && selectedResourceAlreadyPresent.selected && selectedResource.selected) {
                        selectedResourceAlreadyPresent.selected = true;
                        wi.errorMessage = "The resource is already the primary resource for this responsibility";
                        isUpdated = false;
                    }
                    else if (!isChangePresent && !selectedResourceAlreadyPresent.selected && !selectedResource.selected) {
                        selectedResourceAlreadyPresent.selected = false;
                        wi.errorMessage = "The resource is already alternative resource for this responsibility";
                        isUpdated = false;
                    }
                    if (currentAssignee && currentAssignee.userId == selectedResource.userId && !selectedResource.selected) {
                        selectedResourceAlreadyPresent.selected = true;
                        // User which is being updated was the default assignee and is now being made not default is not valid state
                        wi.errorMessage = "The request will result in no primary resource assignment";
                        isUpdated = false;
                    }
                }
            }
            else {
                wi.errorMessage = "Responsibility doesn't exist on Work item";
                isUpdated = false;
            }

        });
        return isUpdated;
    }

    const applyBulkUpdateResources = (responsibility: number[], resource: any, primary: boolean, assignOnInProgress: boolean) => {
        const boResource = resource as GetAutocompleteResult;
        const selectedResource: AssignedUser = {
            userId: boResource.userId,
            userName: boResource.fullName,
            isDefaultAssignee: false,
            selected: primary,
            isNew: false,
            isAssignOnInProgress: assignOnInProgress
        };
        selectedWorkItemRows.map(gridId => {
            var wi = workItemsForBulkUpdateResources!.workItems!.find(x => x.treePath === gridId);
            if (wi != null && responsibility) {
                const isUpdated = validateAndUpdateWorkItem(wi, selectedResource, boResource, responsibility);
                if (isUpdated) {
                    //wi.rowChanged = checkIfRowChanged(wi);
                }
            }
        });
        apiRef.current.updateRows(workItemsForBulkUpdateResources!.workItems!);
        //setChangedData();
    }
    const buildChangeData = (resource: any) => {
        const boResource = resource as GetAutocompleteResult;
        const changedItems: IChangedWorkItemResourceAssigne[] = [];
        var workItems = workItemsForBulkUpdateResources?.workItems;

        selectedWorkItemRows.forEach((treepath) => {
            const selectedWorkItem = workItems?.find(wi => wi.treePath == treepath);
            const changedItem: IChangedWorkItemResourceAssigne = {
                id: treepath as string, // ((selectedItem.workItemInstanceId?.toString() ?? 'workItemInstanceId') + (responsibility?.responsibilityId ?? '1') + (responsibility?.resources?.find((y: AssignedUser) => y.isDefaultAssignee)?.userId ?? 'userId')),
                workItemInstanceId: selectedWorkItem?.workItemInstanceId ?? 0,
                workItemInstanceName: selectedWorkItem?.workItemInstanceName ?? '',
                responsibility: selectedWorkItem?.responsibilityName ?? '',
                responsibilityId: selectedWorkItem?.responsibilityId ?? 0,
                previousPrimaryResource: '', // responsibility?.resources?.find((y: any) => y.isDefaultAssignee)?.userName ?? 'N/A',
                currentPrimaryResource: selectedWorkItem?.primaryResource?.userName ?? '', //!primaryChange ? undefined : ('(P) ' + responsibility?.resources?.find((y: any) => y.selected)?.userName),
                newAlternateResources: [boResource.fullName], //responsibility.resources?.filter((resource: any) => resource.isNew && !resource.selected).map((x: any) => x.userName),
                isAssignOnInProgress: boResource.assignOnInProgress ?? false //responsibility.resources?.find((resource: any) => resource.selected)?.isAssignOnInProgress ?? false
            };
            changedItems.push(changedItem);
        });

        setChangedWorkItems(changedItems);
    }

    const handleReviewConfirmClick = (responsibility: number[], resource: any) => {
        //applyBulkUpdateResources(responsibility, resource, primary, assignOnInProgress);
        const boResource = resource as GetAutocompleteResult;
        buildChangeData(boResource);
        setSelectedResource(boResource);
        openDrawer();
        setUnsavedChanges(true);
    }

    const onReviewChangesConfirm = () => {


        if (!apiRef?.current?.hasOwnProperty('getSelectedRows')) {
            return;
        }
        const workItemsToSave: ISaveWorkItemResourceAssigne[] = [];
        /*
         * WILL BE CLEANED UP IN THE BFLY-12189.
         *
        apiRef.current.getSelectedRows().forEach((selectedItem) => {
            const workItemInstanceId = (selectedItem as WorkItemWithResources).workItemInstanceId;
            if (workItemsToSave.find(x => x.workItemInstanceId === workItemInstanceId)) {
                return;
            }
            (selectedItem as WorkItemWithResources).responsibilitiesResources.forEach((responsibility) => {
                const currentUser = responsibility.resources.find(x => x.isDefaultAssignee);
                const currentUserId = currentUser?.userId;
                const currentUserName = currentUser?.userName;
                responsibility.resources.forEach(resource => {
                    const isChanged = resource.selected && !resource.isDefaultAssignee || resource.isNew;
                    if (isChanged) {
                        const changedItem: ISaveWorkItemResourceAssigne = {
                            workspaceId: selectedItem.workspaceInstanceId,
                            workItemInstanceId: selectedItem.workItemInstanceId,
                            responsibilityId: responsibility.responsibilityId,
                            isDefaultAssignee: resource.selected,
                            isNew: resource.isNew,
                            userId: resource.userId,
                            fromUserId: resource.selected && !resource.isDefaultAssignee ? currentUserId : undefined,
                            fromUserName: resource.selected && !resource.isDefaultAssignee ? currentUserName : undefined,
                            versionStamp: resource.versionStamp,
                            isAssignOnInProgress: resource.isAssignOnInProgress
                        };
                        workItemsToSave.push(changedItem);
                    }
                });
            })
        })
        */
        var workItems = workItemsForBulkUpdateResources?.workItems;
        var resource = selectedResource as GetAutocompleteResult;

        selectedWorkItemRows.forEach((treepath) => {
            const selectedWorkItem = workItems?.find(wi => wi.treePath == treepath);
            if (selectedWorkItem !== null && selectedWorkItem !== undefined) {
                const changedItem: ISaveWorkItemResourceAssigne = {
                    workspaceId: selectedWorkItem.workspaceInstanceId,
                    workItemInstanceId: selectedWorkItem.workItemInstanceId,
                    responsibilityId: selectedWorkItem.responsibilityId,
                    isDefaultAssignee: resource.setAsPrimary ?? false,// resource.selected,
                    isNew: true,//resource.isNew,
                    userId: resource.userId,
                    fromUserId: '', //resource.selected && !resource.isDefaultAssignee ? currentUserId : undefined,
                    fromUserName: '', //resource.selected && !resource.isDefaultAssignee ? currentUserName : undefined,
                    versionStamp: selectedWorkItem.resource.versionStamp,
                    isAssignOnInProgress: resource.assignOnInProgress ?? false
                };
                workItemsToSave.push(changedItem);
            }
        });


        console.log(workItemsToSave);
        if (workItemsToSave.length > 0) {
            setResourceWorkItemsToUpdate(workItemsToSave);
            setTaskTracking(moment.utc().format('YYYY-MM-DDTHH:mm:ss'));
            setDisableSave(true);
        }
        closeDrawer()
    }

    const openDrawer = () => {
        setDrawer(true);
    }

    const closeDrawer = () => {
        setDrawer(false);
    }

    const cleanResults = () => {
        setWorkItemsForBulkUpdateResources(null);
        setDisableSave(false);

        setChangedWorkItems([]);
        setResourceWorkItemsToUpdate([]);
        setSelectedWorkItemIds([]);
        setSelectedWorkItemRows([]);
        setSelectedWorkSpaceIds([]);
        setSaveBulkUpdateResourcesResult(null)
        // setSaveBulkUpdateStatusResult(null);
    }

    const pageTitleUI = (
        <>
            <Box sx={{ display: "flex", maxWidth: '85vw' }}>
                <PageTitle sx={{ color: '#001A69' }}>{pageTitle}</PageTitle>
            </Box>
        </>
    );

    const SearchResultsFilterAndDisclaimer = (
        <>
            <Grid container xs={12} mb={1}>
                <Grid item xs={12} sx={{ textAlign: 'end' }}>
                    Please note that the results <b>don't include</b> Completed or Cancelled Work Items
                </Grid>
            </Grid>
        </>
    );

    const searchUI = (
        <>
            <Box sx={{ pl: '20px' }} id="work-item-search-box">
                <Grid
                    container
                    spacing={{ xs: 2, md: 2 }}
                    columns={{ xs: 1, sm: 1, md: 12, lg: 12 }}>
                    <BulkUpdateSearchResources
                        cancelButtonText={'Cancel'}
                        onCancel={handleOnCancel}
                        onSearch={(payload) => handleSearch(payload, true)}
                    />
                </Grid>
            </Box>
        </>
    );

    const searchResultsUI = (
        <>
        </>
    );

    const workItemsDataGrid = (
        <>
            <Helmet>
                <title>Sage Central | Bulk Update Work Item Resources</title>
            </Helmet>
            <Box id="work-item-grid-box">
                <GridBox getData={getData}>
                    {
                        <Box sx={{ height: "80vh" }}>
                            <DataGridPro
                                sx={{
                                    '& .MuiDataGrid-columnHeaderCheckbox': {
                                        pl: '0px', pr: '5px'
                                    },
                                    '& .MuiDataGrid-cellCheckbox': {
                                        pl: '15px',
                                        '& .Mui-disabled': {
                                            display: 'none'
                                        }
                                    }
                                }}
                                apiRef={apiRef}
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: 'responsibilityName', sort: 'asc' }]
                                    }
                                }}
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                disableColumnPinning
                                rows={getData()}
                                columns={getColumns()}
                                checkboxSelection
                                isRowSelectable={(params) => { return true; }}
                                isCellEditable={(params) => { return false; }}
                                disableRowSelectionOnClick
                                keepNonExistentRowsSelected={true}
                                rowSelectionModel={selectedWorkItemRows}
                                onCellEditStop={rowCellEdited}
                                onRowSelectionModelChange={(newRowSelectionModel) => {
                                    onUpdateSelectedRows(newRowSelectionModel);
                                }}
                                pageSizeOptions={[25, 50, 75, 100]}
                                pagination={getData() && getData().length > 0}
                                slots={{
                                    loadingOverlay: () => (<CircularProgress />),
                                    columnUnsortedIcon: null,
                                    columnMenuSortAscendingIcon: Ico_SortAscending,
                                    columnMenuSortDescendingIcon: Ico_SortDescending,
                                    columnSortedAscendingIcon: Ico_SortAscending,
                                    columnSortedDescendingIcon: Ico_SortDescending,
                                    quickFilterIcon: Ico_Filter_Component,
                                    columnFilteredIcon: Ico_Filter_Component,
                                    quickFilterClearIcon: Ico_Filter_Component,
                                    columnMenuFilterIcon: Ico_Filter_Component,
                                    noRowsOverlay: () => NoRowsOverlay(userSearched),
                                    toolbar: GridToolbar,
                                    row: (props) => WorkItemRow({ props, validateRow, getRowErrorMessage }),
                                    footer: () => CustomFooter(getData().length)
                                }}
                                loading={loadingWorkItemsForBulkUpdateResources}
                                slotProps={{ panel: { placement: "bottom-end" } }}
                            />
                        </Box>

                    }
                </GridBox>
            </Box>
        </>
    );

    const bulkUpdateOperationsUI = (
        <>
            {
                (workItemsForBulkUpdateResources?.workItems) &&
                <Box
                    sx={{
                        mt: '25px',
                        borderRadius: 6,
                        backgroundColor: 'lightblue',
                        pb: '15px',
                        pl: '35px',
                        pr: '-35px'
                    }}
                    id="work-item-bulk-update-box">
                    <Grid
                        container
                        spacing={{ xs: 2, md: 2 }}
                        columns={{ xs: 1, sm: 1, md: 12, lg: 12 }}>

                        <BulkUpdateOpertionsResponsibilities
                            idSuffix={'resources'}
                            selectedWorkItems={selectedWorkItemIds}
                            selectedWorkSpaceIds={selectedWorkSpaceIds}
                            selectedResponsibilityIds={selectedResponsibilityIds}
                            OnReviewConfirmClick={handleReviewConfirmClick}
                        //saveInProgress={disableSave}
                        />
                    </Grid>
                </Box>
            }
        </>
    );

    const DialoguUI = (title: string, opener: boolean, onClose: any, actions: { Text: string, Variant: any, onClick: () => void }[]) => {
        return (
            <>
                <Dialog
                    fullWidth={false}
                    maxWidth={'lg'}
                    onClose={onClose}
                    open={opener}>
                    <DialogTitle
                        sx={{ textAlign: 'left', fontWeight: '600', fontSize: '17px' }}>
                        {<Ico_Warning color='error' sx={{ height: '40px', width: '40px' }} />}
                        <br />
                        {title}
                    </DialogTitle>
                    <DialogContent>
                        <DialogActions
                            sx={{ paddingTop: '10px', width: '100%' }}>
                            {actions.map((action) => (
                                <Button
                                    fullWidth
                                    variant={action.Variant}
                                    onClick={action.onClick}>
                                    {action.Text}
                                </Button>
                            ))
                            }
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </>
        );
    }

    return (
        <div>
            {pageTitleUI}

            {searchUI}

            {SearchResultsFilterAndDisclaimer}

            {searchResultsUI}

            {workItemsDataGrid}
            {saveBulkUpdateResourcesInProgress &&
                <span>
                    <CircularProgress sx={{ left: 0, right: 0 }} color="primary" />
                    <span style={{ margin: '10px 0 0 50px', display: 'inline-block', position: 'absolute' }}>Update in progress..</span>
                </span>
            }

            {bulkUpdateOperationsUI}

            {DialoguUI("You must enter at least 1 search item",
                openEmptySearchCriteriaNotificationDialog,
                setEmptySearchCriteriaNotificationDialog,
                [
                    {
                        Text: "Ok",
                        Variant: "contained",
                        onClick: () => setEmptySearchCriteriaNotificationDialog(!openEmptySearchCriteriaNotificationDialog)
                    }
                ])}

            {DialoguUI("Pending changes may be lost if you leave or change the results",
                showPrompt,
                cancelNavigation,
                [
                    {
                        Text: "Continue",
                        Variant: "contained",
                        onClick: () => confirmNavigation()
                    },
                    {
                        Text: "Cancel",
                        Variant: "outlined",
                        onClick: () => cancelNavigation()
                    }
                ])}

            {DialoguUI("Pending changes may be lost if you leave or change the results",
                openSearchWithoutSaveConfirmation,
                setOpenSearchWithoutSaveConfirmation,
                [
                    {
                        Text: "Continue",
                        Variant: "contained",
                        onClick: () => handleSearch(searchPayload, false)
                    },
                    {
                        Text: "Cancel",
                        Variant: "outlined",
                        onClick: () => setOpenSearchWithoutSaveConfirmation(false)
                    }
                ])}

            {changedWorkItems?.length > 0 &&
                (<WorkItemResourceReviewChanges
                    open={drawer}
                    onClose={closeDrawer}
                    onConfirm={onReviewChangesConfirm}
                    onEdit={closeDrawer}
                    changedItems={changedWorkItems} />)
            }
        </div>
    )
};

export default WorkItemBulkUpdateResources;